import { render } from "./PasswordRecoveryPage.vue?vue&type=template&id=4f6bcff4"
import script from "./PasswordRecoveryPage.vue?vue&type=script&lang=js"
export * from "./PasswordRecoveryPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__